// Export all stores from a single location for easier imports
export { usePersistentStore } from "./persistent";
export { useNonPersistentStore } from "./nonPersistent";

// Lazy store access to avoid calling before Pinia is initialized
let nonPersistentStoreInstance = null;
let persistentStoreInstance = null;

export const getNonPersistentStore = () => {
  if (!nonPersistentStoreInstance) {
    const { useNonPersistentStore } = require("./nonPersistent");
    nonPersistentStoreInstance = useNonPersistentStore();
  }
  return nonPersistentStoreInstance;
};

export const getPersistentStore = () => {
  if (!persistentStoreInstance) {
    const { usePersistentStore } = require("./persistent");
    persistentStoreInstance = usePersistentStore();
  }
  return persistentStoreInstance;
};
